import { render } from "./default.layout.vue?vue&type=template&id=cb7d8568"
const script = {}

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__